import React from "react";
import "./styles.scss";
import { ClientLocal } from "app/api/types";
import _ from "lodash";

interface IProps {
	clientInfo: ClientLocal;
}

interface IState {

}

class ChatFormUser extends React.Component<IProps, IState> {
	render() {
		const lastMessage = _
			.sortBy(this.props.clientInfo.messages ?? [], 'time')
			.reverse()
			.find(x => !!x);

		return (
			<div className={'chat-form-user'}>
				<div className={'chat-form-user__date time'}>
					{ lastMessage?.time.toLocal().toFormat('HH:mm dd.MM.yyyy') ?? 'Недавно' }
				</div>
				<div className={'phrase-container'}>
					<p className={'chat-form-user__name edit-phrase__label'}>
						{ this.props.clientInfo.companionName }
						{ this.props.clientInfo.companionPhone ? ` (т. ${this.props.clientInfo.companionPhone})` : '' }
					</p>
					<p className={`chat-form-user__message ${lastMessage?.isIncoming ? '' : 'edit-phrase__label'}`}>
						{ lastMessage?.text ?? '--'}
					</p>
				</div>
			</div>
		);
	}
}

export default ChatFormUser;
